var paddingTop = 0;

/**
 * Check a href for an anchor. If exists, and in document, scroll to it.
 * If href argument ommited, assumes context (this) is HTML Element,
 * which will be the case when invoked by jQuery after an event
 */
function scrollToAnchor(href) {
    // If our Href points to a valid, non-empty anchor, and is on the same page (e.g. #foo)
    // Legacy jQuery and IE7 may have issues: http://stackoverflow.com/q/1593174
    if (href.indexOf('#') === 0 && href.length > 1) {
        var $target = $(href);
        var scrollTarget = $target.offset().top - paddingTop;

        // Older browser without pushState might flicker here, as they momentarily
        // jump to the wrong position (IE < 10)
        if ($target.length) {
            var history;
            $('html, body').animate({ scrollTop: scrollTarget });
            if (history && 'pushState' in history) {
                history.pushState({}, document.title, window.location.pathname + href);
                return false;
            }
        }
    }
}

function onClickAnchorLink(e) {
    e.preventDefault();
    var clicked = $(e.currentTarget);
    scrollToAnchor(clicked.attr('href'));
}

function onDocumentReady() {
    // When our page loads, check to see if it contains and anchor
    if (window.location.hash) {
        scrollToAnchor(window.location.hash);
    }

    // Intercept all anchor clicks
    $('body').on('click', 'a[href^="#"]', onClickAnchorLink);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
